module.exports = __webpack_public_path__ + "static/media/Icon 7.68c27605.png";